import { message } from 'antd'

export const base64ToBlob = (base64: string, contentType: string): Blob => {
  const binaryString = atob(base64)
  const bytes = new Uint8Array(binaryString.length)

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  return new Blob([bytes], { type: contentType })
}

type BaseBlobOperationProps = {
  getBlob: () => Promise<Blob>
  operationText: string
  onStarted?: () => void
  onFinished?: () => void
}

type DownloadBlobOperationProps = BaseBlobOperationProps & {
  downloadFilename: string
}

export const useOpenBlobInNewTab =
  () =>
  async ({ getBlob, operationText, onStarted, onFinished }: BaseBlobOperationProps) => {
    try {
      onStarted?.()
      const blob = await getBlob()
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.target = '_blank'
      link.click()
      window.setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl)
      }, 60_000)
    } catch (e) {
      console.error(`There was an error ${operationText}`, e)
      message.error(`Failed to ${operationText}`)
    } finally {
      onFinished?.()
    }
  }

export const useDownloadBlob =
  () =>
  async ({ getBlob, downloadFilename, operationText, onStarted, onFinished }: DownloadBlobOperationProps) => {
    try {
      onStarted?.()

      const blob = await getBlob()
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = downloadFilename
      link.click()
      window.setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl)
      }, 1_000)
      return true
    } catch (e) {
      console.error(`There was an error ${operationText}`, e)
      message.error(`Failed to ${operationText}`)
      return false
    } finally {
      onFinished?.()
    }
  }
